function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1061",
  "data-name": "Group 1061",
  transform: "translate(-115 -111)",
  opacity: 0.75
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_46",
  "data-name": "Ellipse 46",
  cx: 6,
  cy: 6,
  r: 6,
  transform: "translate(115 111)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_937",
  "data-name": "Group 937",
  transform: "translate(119 115)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_12",
  "data-name": "Line 12",
  x2: 4,
  y2: 4,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_13",
  "data-name": "Line 13",
  y1: 4,
  x2: 4,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1
})));

var SvgDarkClose = function SvgDarkClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDarkClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dark-close.bb9c829d.svg";
export { ForwardRef as ReactComponent };